import { useQuery } from '@tanstack/react-query';
import {
  companyListQueryOptions,
  departmentListQueryOptions,
} from '@/features/organization/api/organization.api';
import { useGeoCascade } from '@/hooks/useGeoCascade';
import { FILTER_KEYS, parseNumberFilter } from '@/utils/filters';

export function useOrgGeoFilterOptions(values: Record<string, string>) {
  const companyId = parseNumberFilter(values[FILTER_KEYS.companyId]);

  const { data: companies } = useQuery(companyListQueryOptions());
  const { data: departments } = useQuery(
    departmentListQueryOptions(companyId === undefined ? {} : { companyId }),
  );
  const { divisions, districts, thanas } = useGeoCascade({
    divisionId: parseNumberFilter(values[FILTER_KEYS.divisionId]),
    districtId: parseNumberFilter(values[FILTER_KEYS.districtId]),
  });

  return { companies, departments, divisions, districts, thanas };
}
